import { LogoutReasons } from "@/libs/auth/types";

export const enum EVENTS {
  ACCOUNT_TOKEN_UPDATE = "account-access-token-update",
  ACCOUNT_LOGOUT = "account-logout",
}

type EventMap = {
  [EVENTS.ACCOUNT_TOKEN_UPDATE]: string;
  [EVENTS.ACCOUNT_LOGOUT]: LogoutReasons;
};

export function addCustomEventListener<T extends keyof EventMap>(
  type: T,
  listener: (event: CustomEvent<EventMap[T]>) => void,
) {
  window.addEventListener(type, listener as never);
}

export function removeCustomEventListener<T extends keyof EventMap>(
  type: T,
  listener: (event: CustomEvent<EventMap[T]>) => void,
) {
  window.removeEventListener(type, listener as never);
}

export function dispatchCustomEvent<T extends keyof EventMap>(
  ...args: EventMap[T] extends undefined
    ? [type: T]
    : [type: T, detail: EventMap[T]]
) {
  window.dispatchEvent(new CustomEvent(args[0], { detail: args[1] }));
}
